import React, { useState, useRef } from "react";
import SweetAlert from "sweetalert2";
import { connect } from "react-redux";
import { withStyles } from '@mui/styles';
import FormStepperContainer from "../../../../stepper/FormStepperContainer";
import FormBlocContainer from "../../../../layout/form/FormBlocContainer";
import NumSSInput from "../../../../layout/form/inputs/text/NumSSInput";
import NumSSKeyInput from "../../../../layout/form/inputs/text/NumSSKeyInput";
import LastnameInput from "../../../../layout/form/inputs/text/LastnameInput";
import SSDateInput from "../../../../layout/form/inputs/date/SSDateInput";
import DefaultLayout from "../../../../../components/layout/DefaultLayout";
import InsuredRegistrationService from "../../../../../api/extranet/services/InsuredRegistrationService";
import { toggleLoading } from "../../../../../store/slices/loadingSlice";
import withKeycloak from "../../../../../helpers/hooks/class/withKeycloak";
import PathManager from "../../../../../helpers/PathManager";
import withReactContent from "sweetalert2-react-content";
import StringHelper from "../../../../../helpers/StringHelper";
import WaitHelper from "../../../../../helpers/WaitHelper";
import { Grid } from "@mui/material";
import { useHistory } from 'react-router-dom';
import Button from "@mui/material/Button";
import AbstractExtranetRegisterStepper from "../../../../stepper/AbstractExtranetRegisterStepper";
const ReactSweetAlert = withReactContent(SweetAlert);
const forgotPasswordUrl = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/login-actions/reset-credentials?client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}`;


class VerificationStep extends AbstractExtranetRegisterStepper {

    state = {
        ssNum: '',
        ssKey: '',
        lastname: '',
        birthdate: '',
        insuredData: {},
    };

    /**
     * Lifecycle callbacks
     */

    constructor(props) {
        super(props);
        this.mainForm = React.createRef();
        this.pathManager = new PathManager(this.props.history)
    }

    /**
     * Functions
     */

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    handleVerificationNext = () => {
        const _that = this;
        this.mainForm.current.isFormValid(false).then(async (value) => {
            if (value) {
                const verification = await _that.verifyInsured();
                if (verification.isExists) {
                    _that.showExistsInsured();
                } else if (verification.isAble) {
                    WaitHelper.setWaitTimeForFunc(() => {_that.props.handleNext(_that.state);}, 100);
                } else {
                    _that.showIsNotAbleToCreateAccountAlert();
                }
            } else {
                _that.scrollToError();
            }
        })
    }

    verifyInsured = async () => {
        this.props.toggleLoading();
        const numSS = StringHelper.unformatSSNum(this.state.ssNum);
        const { ssKey, lastname, birthdate } = this.state;
        const isAbleToRegister = await InsuredRegistrationService.isAbleToRegister(numSS,ssKey,lastname,birthdate);
        if (isAbleToRegister.isAble) {
            this.setState({insuredData: isAbleToRegister.data})
        }
        this.props.toggleLoading();
        return isAbleToRegister;
    }

    showExistsInsured = () => {
        SweetAlert.fire({
            title: `<i class="fas fa-exclamation-circle"></i> Impossible de créér le </br></br> compte`,
            html: `<p>Ce numéro de sécurité social a déjà un compte existant, souhaitez-vous vous connecter ou réinitialiser votre mot de passe ?</p>`,
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: "#EF595D",
            cancelButtonText: 'Non',
            showConfirmButton: true,
            confirmButtonColor: "#545760",
            confirmButtonText: 'Oui',
            allowOutsideClick: false,
        }).then((confirm) => {
            if (confirm.value) {
              //  this.props.keycloak.login();
                window.location.href = forgotPasswordUrl;

            }
        })
    }

    handleRedirectContactForm = (event) => {
        event.stopPropagation();
        const data = {
            lastname: this.state.lastname,
            birthdate: this.state.birthdate,
            ssNum: this.state.ssNum
        }
        this.pathManager.goTo('contact-insured', '', data);
        SweetAlert.close();

    }

    showIsNotAbleToCreateAccountAlert = () => {
        const { lastname, birthdate, ssNum } = this.state;
        ReactSweetAlert.fire({
            title: `<i class="fas fa-exclamation-circle"></i> <span>Besoin d'aide ?</span>`,
            html: <p>
                Après vérification de vos données, nous ne retrouvons pas votre dossier.
                Afin de pouvoir créer votre compte assuré, vous devez <b>percevoir des prestations en direct</b> par Uniprévoyance.
                <br/>
                Si vous rencontrez des difficultés alors que vous bénéficiez bien de nos prestations, vous pouvez nous contacter en cliquant&nbsp;
                <a href="#" onClick={this.handleRedirectContactForm}>ici</a>
            </p>,
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#EF595D",
            cancelButtonText: 'Fermer',
            showConfirmButton: false,
            allowOutsideClick: false
        });
    }

    scrollToError = () => {
        const element = document.querySelector('div[class*="error"]');
        if (element) {
            let rect = element.getBoundingClientRect();
            window.scrollTo(0, window.scrollY + rect.top - 100);
        }
    }

    render() {
        return <DefaultLayout>
            <FormStepperContainer
                ref={this.mainForm}
                label={"Formulaire vérification"}
                activeStep={this.props.activeStep}
                nbStep={this.props.nbStep}
                id={this.state.id}
                handleBack={this.props.handleBack}
                handleNext={this.handleVerificationNext}
            >

                <Grid container spacing={3} sx={{ marginTop: 3 }}>
                    <FormBlocContainer>
                        <Grid item xs={0} sm={1}></Grid>
                        <Grid item xs={12} sm={6} sx={{ paddingRight: 2, marginBottom: 2 }}>
                            <NumSSInput
                                name="ssNum"
                                value={this.state.ssNum}
                                handleChange={this.handleChange}
                                isLoading={this.state.isInputLoading}
                                isValidInput={this.state.isSSNumValid}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{ paddingRight: 2, marginBottom: 2 }}>
                            <NumSSKeyInput
                                name="ssKey"
                                value={this.state.ssKey}
                                handleChange={this.handleChange}
                                ss={this.state.ssNum}
                            />
                        </Grid>
                        <Grid item xs={0} sm={1}></Grid>
                        <Grid item xs={0} sm={1}></Grid>
                        <Grid item xs={12} sm={6} sx={{ paddingRight: 2, marginBottom: 3 }}>
                            <LastnameInput
                                name="lastname"
                                value={this.state.lastname}
                                handleChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} sx={{ paddingRight: 2, marginBottom: 3 }}>
                            <SSDateInput
                                name="birthdate"
                                value={this.state.birthdate}
                                handleChange={this.handleChange}
                                ss={this.state.ssNum}
                            />
                        </Grid>
                        <Grid item xs={0} sm={1}></Grid>
                        <Grid item xs={0} sm={1}>
                        </Grid>
                        <Grid item xs={6} sm={5} sx={{ marginTop: -5 }}>
                         <p className="legende">*Champs obligatoires</p>
                        </Grid>
                        <Grid item xs={6} sm={5}>
                        </Grid>
                    </FormBlocContainer>
                </Grid>
            </FormStepperContainer>
        </DefaultLayout>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleLoading: () => dispatch(toggleLoading())
    };
};

export default withStyles(null, { withTheme: true })(withKeycloak(connect(null, mapDispatchToProps)(VerificationStep)));
